<template>
  <div>
    <el-card shadow="always" style="box-shadow:none;">
      <EditForm
        ref="editForm"
        :formDisabled="formDisabled"
        :imageDisabled="imageDisabled"
        :isChangeName="isChangeName"
        :form="formData"
        @reload="reload"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsSample-sampleInfo-detail',
  components: {
    EditForm,
  },
  data() {
    return {
      formData: {},
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    amzSampleCode() {
      return this.params.amzSampleCode
    },
    //禁用表单 + 保存按钮 控制 禁用表单时保存按钮不显示
    formDisabled() {
      return this.pageType === 'detail'
    },
    //图片维护按钮控制
    imageDisabled() {
      return this.pageType === 'detail' || this.pageType === 'add'
    },
    isChangeName() {
      return this.pageType === 'changeName'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    getData() {
      if (!this.amzSampleCode) return
      this.$api
        .ecomAmzSampleDetailApi({
          amzSampleCode: this.amzSampleCode,
        })
        .then((res) => {
          this.formData = res?.body || {}
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.edit_form {
  padding: 15px 15px 5px 15px;
  border-radius: 5px;
  background-color: #fff;
}
.mt_10 {
  margin-top: 10px;
}
</style>
